import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  CircularProgress,
} from '@mui/material';
import GoalStaticsTeamRow from './GoalStaticsTeamRow';

const GoalStaticsTeamTable = ({ loading, data, tableRef, headerRows, selectedLabel }) => {
  if (loading || !data) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ my: 1 }}>
      {/* 1. (단위:원)을 Paper 바깥으로 이동하여 상단 선 간섭 제거 */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.5, pr: 1, fontSize: '0.8rem', color: '#666' }}>
        (단위:원)
      </Box>

      {/* 2. 테이블 본체 */}
      <Paper elevation={1} sx={{ overflow: 'auto' }}>
        <TableContainer>
          <Table 
            size="small" 
            ref={tableRef}
            sx={{ 
              tableLayout: 'fixed',
              borderCollapse: 'collapse',
              // [전체 셀 스타일링]
              '& .MuiTableCell-root': {
                border: '1px solid #e0e0e0',
                padding: '4px 8px',
                fontSize: '0.85rem',
                height: '40px',
              },
              // [헤더 기본 스타일링]
              '& .MuiTableHead-root .MuiTableCell-root': {
                backgroundColor: '#f5f5f5',
                fontWeight: 'bold',
                color: '#333',
              },
              // [하늘색 배경 - 글자색 검정(#333)으로 통일]
              '& .header-sky': {
                backgroundColor: '#e3f2fd !important',
                color: '#333',
              }
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell align="center" rowSpan={2} sx={{ color: '#333', fontWeight: 'bold' }}>본부</TableCell>
                <TableCell align="center" rowSpan={2} sx={{ color: '#333', fontWeight: 'bold' }}>팀</TableCell>
                {/* 목표금액 헤더 */}
                <TableCell align="center" colSpan={headerRows.length} className="header-sky" sx={{ fontWeight: 'bold' }}>
                  {selectedLabel} 목표
                </TableCell>
              </TableRow>
              <TableRow>
                {headerRows.map((header, index) => (
                  <TableCell key={index} align="center" className="header-sky" sx={{ fontWeight: 'bold' }}>
                    {header !== 'total' ? `${header}월` : `합계`}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <GoalStaticsTeamRow data={data} headers={headerRows} />
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default GoalStaticsTeamTable;
